import styled from 'styled-components';
const CarouselSliderWrapper = styled.div`
  .carousel .thumbs {
    display: none;
  }
  .carousel .thumbs-wrapper {
    display: none;
  }

  .carousel .slider-wrapper {
    border-radius: 12px;
  }

  .carousel carousel-slider {
    width: auto;
  }
  .carousel.carousel-slider .control-arrow {
    display: none;
  }
  .motorImg {
    text-align: initial;
    img {
      width: 32px;
      height: 32px;
      @media only screen and (min-width: 1030px) and (max-width: 1366px) {
        margin-top: -13px;
        width: 26px;
        height: 26px;
        margin-bottom: 25px;
      }

      @media only screen and (min-width: 1370px) and (max-width: 2000px) {
        margin-top: -5px;
      }
    }
  }
  .motorText {
    font-size: 1.5rem;
    font-weight: 800;
    line-height: 2rem !important;
    text-align: initial;
    color: white;
    white-space: pre-line;
    @media only screen and (min-width: 1030px) and (max-width: 1366px) {
      line-height: 12px;
      margin-top: -14px;
    }

    @media only screen and (min-width: 1370px) and (max-width: 2000px) {
      line-height: 17.8px;
    }
  }
  .motorPara {
    font-size: .9rem;
    font-weight: normal;
    line-height: 160%;
    text-align: initial;
    width:75%;
    margin-top:1rem;
    margin-bottom:.8rem;
    color: white;
    @media only screen and (min-width: 1030px) and (max-width: 1366px) {
      line-height: 14px;
      font-size: 0.7rem;
      margin: 10px 0;
    }
    @media only screen and (min-width: 1370px) and (max-width: 2000px) {
      line-height: 17.8px;
      font-size: 0.9rem;
    }
  }
  .learnMore {
    margin-top:1rem
    height: 16px;
    border-radius: null;
    font-size: 1rem;
    font-weight: 800;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: initial;
    display:flex;
    align-items: center;
    gap:.5rem;
    color: white;
    @media only screen and (min-width: 1370px) and (max-width: 2000px) {
      height: 8px;
      font-size: 0.7rem;
      margin-top: -10px;
    }

    @media only screen and (min-width: 1370px) and (max-width: 2000px) {
      height: 16px;
      font-size: 1rem;
      margin-top: 10px;
    }
  }
  .learnMoreImg {
    width: 35px;
    background: #6B47F5;
    border-radius: 100px;
    padding:.7rem;
  }
  .dot {
    margin: 0 4px !important;
    background: #fff;
    opacity: .3 !important;
    filter: none;
    box-shadow: none;
    background: white;
    color: white;
  }
  .dot.selected {
    margin: 0 4px !important;
    background: #fff;
    opacity: 1 !important;

  }
  .carousel .carousel-status {
    display: none;
  }
  .main-div-rtl {
     direction: initial;
    // .carousel .slider.animated {
    //   transform: translate3d(0%, 0px, 0px) !important;
    //   transition-duration: 350ms;
    // }
  }
  .text-overlay {
    position: absolute;
    top: 32px;
    left: 25px;
    right: 25px;
  }
  .carousel .control-dots {
    position: absolute;
    bottom: 0;
    margin: 10px 0px;
    padding: 0;
    text-align: end;
    width: 100%;
    z-index: 1;
    top: 16px;
    right: 25px;
    @media only screen and (min-width: 1030px) and (max-width: 1366px) {
      top: 4px;
      right: 25px;
    }
    @media only screen and (min-width: 1370px) and (max-width: 2000px) {
      top: 16px;
      right: 25px;
      height: 30px;
    }
  }
  .main-div-rtl {
    .carousel {
      .control-dots {
        text-align: right;
        right: 80%;
      }
    }
    .text-overlay {
    position: absolute;
    top: 32px;
    left: unset !important;
    right: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap:1rem
  }
    .motorText {
      direction:rtl;
     text-align: right;
     width:40%
    }
    .motorPara {
      width:60%;
      text-align: right !important;
    }
    .learnMoreImg {
      transform:rotate(180deg);
    }
  }
.play-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.play-slide {
  width: auto; /* Set a specific width */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor:pointer;
}

.play-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

  // @media only screen and (min-width: 1370px) and (max-width: 2000px) {
  //   .carousel .slide .carousel-img {
  //     width: 100%;
  //     vertical-align: top;
  //     border: 0;
  //     background-size: cover;
  //     height: 30vh;
  //   }
  // }

  // @media only screen and (min-width: 1370px) and (max-width: 2000px) {
  //   .carousel .slide .carousel-img {
  //     width: 100%;
  //     vertical-align: top;
  //     border: 0;
  //     background-size: cover;
  //     height: 24vh;
  //   }
  // }
  @media only screen and (max-width: 567px){
     .motorText {
        font-size:.9rem !important;
        line-height: 15.8px !important;
     }
    .motorPara {
      font-size: .8rem;
      width:85%;
      line-height:1rem;
    }
    .learnMore{
      font-size:.8rem;
      margin-top:5px;
    }
  }

  }
`;




export default CarouselSliderWrapper;
